/**
 * Canonical labels for ProjectDetail tabs.
 *
 * Single source of truth shared by the ProjectDetail tab bar and Breadcrumbs
 * so the same feature never shows different names on different surfaces.
 * Covers every TabType id, including currently hidden tabs, so breadcrumbs
 * always resolve to a human label instead of a kebab-case slug.
 */
export const PROJECT_TAB_LABELS: Record<string, string> = {
  overview: 'Overview',
  activity: 'Activity',
  documents: 'Knowledge Base',
  chat: 'AI Chat',
  'analyst-workspace': 'Analyst Workspace',
  voice: 'RC Voice Partner',
  analysis: 'Analysis',
  legal: 'Legal Documents',
  cim: 'CIM Analysis',
  'financial-model': 'AI Financial Model',
  'sector-research': 'Sector Research',
  'transaction-search': 'Transaction Search',
  presentations: 'Presentations',
  benchmarks: 'Benchmarks',
  'ic-committee': 'IC Committee',
  ddq: 'DDQ',
  'due-diligence': 'Financial Due Diligence',
  'ic-memo': 'IC Memo',
  'ic-presentation': 'IC Presentations',
  'model-generator': 'AI Financial Model',
  infographics: 'Graphics Studio',
  questions: 'Questions',
  'competitive-intel': 'Competitive Intelligence',
  'customer-cube': 'Customer Cube',
  'deal-comparison': 'Deal Comparison',
  'excel-intelligence': 'Excel Intelligence',
};

/** Human label for a project tab id; falls back to the raw id for unknowns. */
export function projectTabLabel(tabId: string): string {
  return PROJECT_TAB_LABELS[tabId] ?? tabId;
}
